module.exports = __webpack_public_path__ + "img/sms.f37c047e.png";